











































































































































































































































































































































































































































































































































































































































































import AccountOptions from '@/models/AccountOptions'
import { Watch, Vue, Component, Prop } from 'vue-property-decorator'
import { sellerNameModeDict } from '@/dictionary/SellerNameModeDict'
import { Dictionary } from '@/dictionary/Dictionary'
import { getDefaultAccountOptions } from '@/components/helper'
import { itemNameModeDict } from '@/dictionary/ItemNameModeDict'
import { senderNameModeDict } from '@/dictionary/SenderNameModeDict'
import { senderContactInfoSourceDict } from '@/dictionary/SenderContactInfoSourceDict'
import { paymentUpdateModeDict } from '@/dictionary/PaymentUpdateModesDict'
import { barcodesPrintDict } from '@/dictionary/BarcodesPrintDict'
import { tariffSortingDitc } from '@/dictionary/TariffSortingDics'
import { ProductProperty } from '@/models/ProductProperty';

@Component
export default class AccountOptionsComponent extends Vue {
    @Prop({ type: Object, default: () => ({}) })
    private currentAccountOptions: AccountOptions

    @Prop({ type: Array, default: () => ([]) })
    private productProperties: Array<ProductProperty>

    @Prop({ type: Boolean, default: false })
    readonly hasDeliveryCostRules!: boolean

    private selectedAccountOptions: AccountOptions = getDefaultAccountOptions()

    @Watch('currentAccountOptions')
    selectedOptions(): void {
        this.selectedAccountOptions = Object.assign({}, this.currentAccountOptions)
    }

    updateOption(code: string): void {
        if (this.selectedAccountOptions[code]) {
            this.$emit('updateAccountOptionEvent', this.selectedAccountOptions[code])
        }
    }

    removeFieldFromChecked(optionName: string, field: string): void {
        const values = this.selectedAccountOptions[optionName].value as Array<string>
        const nonExistValue = !values.find(value => value === field)

        if (nonExistValue) {
            values.push(field)
        } else {
            const index = values.findIndex(value => value === field)
            values.splice(index, 1)
        }

        this.updateOption(optionName)
    }

    get barcodesPrintListDict(): Array<Dictionary> {
        return barcodesPrintDict
    }

    get sellerNameModeDict(): Array<Dictionary> {
        return sellerNameModeDict
    }

    get senderNameModeDict(): Array<Dictionary> {
        return senderNameModeDict
    }

    get itemNameModeDict(): Array<Dictionary> {
        return itemNameModeDict
    }

    get senderContactInfoSourceDict(): Array<Dictionary> {
        return senderContactInfoSourceDict
    }

    get paymentUpdateModes(): Array<Dictionary> {
        return paymentUpdateModeDict
    }

    get tariffSorting(): Array<Dictionary> {
        return tariffSortingDitc
    }

    get isVisibleSellerCustomName(): boolean {
        return this.selectedAccountOptions.sellerNameMode.value === 'custom'
    }

    get isVisibleSenderNameMode(): boolean {
        return this.selectedAccountOptions.senderNeedAdditionalInfo.value === true
    }

    get isNeedRecalculate(): boolean {
        return this.selectedAccountOptions.recalculateCostByProperty.value === true
    }

    get isVisibleSenderCustomName(): boolean {
        return this.selectedAccountOptions.senderNameMode.value === 'custom' &&
            this.selectedAccountOptions.senderNeedAdditionalInfo.value === true
    }
}
